import React from "react";
import { Link } from "react-router-dom";
import useContent from "../../services/contentful/content";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const DrugPricingTool2022 = () => {
  const [content, isLoading] = useContent("1O21i5gpbvf3wEXWxE0XPA");

  if (isLoading) return <p>Loading...</p>;

  return (
    <div
      role="main"
      className="main-container pt-md-5 pb-5 container js-quickedit-main-content"
    >
      <div className="row d-md-flex">
        <section className="col-sm-12 internal-page">
          <div className="region region-content">
            <section
              id="block-clearstonebreadcrumbs"
              className="block block-clearstone-updates block-clearstone-breadcrumbs-block clearfix"
            >
              <div className="breadcrumb-wrap">
                <div className="region--breadcrumb nst-1">
                  <section
                    id="block-ttheme-breadcrumbs"
                    className="block-system block-system-breadcrumb-block"
                  >
                    <div role="navigation">
                      <ol className="breadcrumb">
                        <li>
                          <Link to="/">Home</Link>
                        </li>
                        <li>Drug Pricing Tool MedicareBlue 2022</li>
                      </ol>
                    </div>
                  </section>
                </div>
              </div>
            </section>

            <h2>
              <ReactMarkdown children={content.title} />
            </h2>

            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              children={content.premiumGrids}
            />
            <br />

            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              children={content.tool}
            />

            {/* <h1 className="page-header">Estimate your costs for 2020</h1> */}

            {/* <article className="page full clearfix">
              <span
                property="schema:name"
                content="Drug Pricing Tool MedicareBlue 2020"
                className="hidden"
              ></span>

              <div className="content">
                <div
                  property="schema:text"
                  className="field field--name-body field--type-text-with-summary field--label-hidden field__item"
                >
                  <div style={{ width: "10%", float: "right" }}>
                    <Link
                      to="enroll/2020-enroll-now.html"
                      className="btn btn-default"
                    >
                      Enroll Now
                    </Link>
                  </div>
                  <br />
                  <table style={{ width: "100%" }} className="t3">
                    <tr>
                      <th scope="col" style={{ textTransform: "none" }}>
                        Plan
                      </th>
                      <th scope="col" style={{ textTransform: "none" }}>
                        Monthly premium
                      </th>
                      <th scope="col" style={{ textTransform: "none" }}>
                        Annual deductible
                      </th>
                    </tr>
                    <tr>
                      <td>MedicareBlue Rx Standard</td>
                      <td>$42.00</td>
                      <td>
                        $0 for drugs on Tiers 1 & 2 &mdash; $435 for drugs on
                        Tiers 3-5
                      </td>
                    </tr>
                    <tr>
                      <td>MedicareBlue Rx Premier</td>
                      <td>$89.60</td>
                      <td>$0 for drugs on all Tiers</td>
                    </tr>
                  </table>
                  <h2 className="alert" style={{ margin: 0, padding: 0 }}>
                    Drug price quotes are estimates and may differ from what you
                    pay at your pharmacy
                  </h2>
                </div>
              </div>
            </article> */}
          </div>
        </section>
      </div>
    </div>
  );
};

export default DrugPricingTool2022;
